export default __webpack_public_path__ + "static/media/user-team.233d3502.svg";